import { useSessionStorage } from "@mantine/hooks";
import type { SupportedAgent } from "@src/gql/graphql";
import { useCallback } from "react";

export const AGENT_MODEL_STORAGE_KEY = "local-selected-agent-ids";
const STORAGE_KEY = AGENT_MODEL_STORAGE_KEY;
const CARD_PREFIX = "card-";

interface LocalAgentStorage {
	[key: string]: SupportedAgent | null;
}

export function useAgentModelStore(shapeId?: string) {
	const storageKey = `${CARD_PREFIX}${shapeId}`;

	const [allAgents, setAllAgents] = useSessionStorage<LocalAgentStorage>({
		key: STORAGE_KEY,
		defaultValue: {},
		getInitialValueInEffect: false,
		sync: false,
	});

	const selectedAgentId = allAgents[storageKey] ?? undefined;

	const setSelectedAgentId = useCallback(
		(agentId: SupportedAgent) => {
			setAllAgents((prev) => ({
				...prev,
				[storageKey]: agentId,
			}));
		},
		[storageKey, setAllAgents],
	);

	return { selectedAgentId, setSelectedAgentId };
}
